var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.reports },
    [
      _c("reports-title", { attrs: { title: _vm.pageTitle } }),
      _vm._v(" "),
      _c("reports-toolbar", {
        attrs: {
          "toolbar-disabled": _vm.isStub,
          "report-title": _vm.pageTitle,
          "toolbar-year-switch-data": _vm.toolbarYearSwitchData,
        },
        on: { setYear: _vm.setYear },
      }),
      _vm._v(" "),
      _vm.isShowSkeleton
        ? _c("skeleton-wrapper", {
            attrs: { id: "skeletonWrapper" },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          class: [
                            _vm.$style.chart_wrapper,
                            _vm.$style.chart_wrapper_scatter,
                            _vm.isShowSkeleton && !_vm.projectsMilestones.total
                              ? _vm.$style.stub
                              : "",
                          ],
                        },
                        [
                          _c("milestones-chart", {
                            attrs: {
                              id: "report_export_id",
                              data: _vm.stubMilestones,
                              "current-year":
                                _vm.toolbarYearSwitchData.currentYear,
                              small: _vm.small,
                              "show-stub-message": false,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4151750475
            ),
          })
        : _c(
            "div",
            {
              class: [
                _vm.$style.chart_wrapper,
                _vm.$style.chart_wrapper_scatter,
                _vm.isStub && !_vm.projectsMilestones.total
                  ? _vm.$style.stub
                  : "",
              ],
            },
            [
              _c("milestones-chart", {
                attrs: {
                  id: "report_export_id",
                  data: _vm.projectsMilestones,
                  "current-year": _vm.toolbarYearSwitchData.currentYear,
                  small: _vm.small,
                  "all-statuses": _vm.allStatuses,
                },
                on: {
                  dataExists: _vm.checkData,
                  setYearRange: _vm.setYearRange,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }